import { SITE_CONFIG, SUPPORT_MAILTO } from "./site";

/** Public contact shown across the site. Replace with an official domain email before listing submission. */
export const SUPPORT_EMAIL = SITE_CONFIG.supportEmail;
export { SUPPORT_MAILTO };
